import React from "react";

import Guest from "../../../layouts/Guest";
import EventCheckAdminForm from "views/Forms/Private/EventCheckForm/EventCheckAdminForm";

function EventCheckInSearchPage() {

  return (
    <>
      <Guest>
        <EventCheckAdminForm />
      </Guest>
    </>
  );
}

export default EventCheckInSearchPage;
